Vue.component('ack-video-gallery', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-video-gallery',
    mixins: [languageMixins],
    created() {
      
    },
    mounted() {
      appLog.log('ack-video-gallery mounted')
      let urlParams = new URLSearchParams(window.location.search);
      let hasId = urlParams.has('videoId')
      let videoId = urlParams.get('videoId')

      if (hasId) {
        let video = this.videos.find((item) => {
          return item.id == videoId
        })

        if (video != null) {
          this.selectVideo(video)
        }
      }

      this.setPageIsLoading(false)
    },
    props:{
      // dataIn: {
      //   type: Object,
      //   required: true
      // }
      isMobile: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      //...Vuex.mapGetters('sliders', ['slidersLists']),
      //...Vuex.mapGetters('articles', ['articlesArray']),
      isMobile(){
        return this.$parent.isMobile
      },
      currentVideoTitle() {
        return this.currentVideo.title
      },
      currentVideoURL() {
        return `https://www.youtube.com/embed/${
          this.currentVideo.id
        }`

      }
    },
    data() {
      return {
        pageId: 'video-gallery-page',
        message: 'Hello Vue!',
        numberOfVideosInSlider: 3,
        displayingVideo: false,
        displayingSearchResults: false,
        currentVideo: null,
        searchTerms: null,
        searchResults: [],
        videos: [

          // 'img': 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ackuretta-webinar_jpg.png?v=1655271989',
    // https://www.youtube.com/embed/

// sol
          // {
          //   'img': null,
          //   'id': 'qVPSi2zUI6c',
          //   'title': "SOL - Meet SOL",
          //   'index': 0,
          //   'length': 0,
          //   'type': 'Intro',
          //   'tags': [
          //     'sol', 'intro', '3Dprinter'
          //   ],
          //   'date': '2019-06-29T15:50+00Z',
          //   'section': 'sol'

          // },
          {
            'img': null,
            'id': 'gABNejrb8tc',
            'title': "SOL - High Speed & Ultra Accurate",
            'index': 0,
            'length': 2,
            'type': 'Intro',
            'tags': [
              'sol', 'intro', '3Dprinter'
            ],
            'date': '2019-03-29T15:50+00Z',
            'section': 'sol'
          },
          {
            'img': null,
            'id': 'EsgMKUlF0-c',
            'title': "SOL - Unboxing SOL",
            'index': 1,
            'length': 3,
            'type': 'Unboxing',
            'tags': [
              'sol', 'operation'
            ],
            'date': '2023-07-11T15:50+00Z',
            'section': 'sol'
          },
          {
            'img': null,
            'id': 'uQ7fpYUh67c',
            'title': "SOL - Heater Setup",
            'index': 2,
            'length': 1,
            'type': 'Operation',
            'tags': [
              'sol', 'operation'
            ],
            'date': '2023-07-11T15:50+00Z',
            'section': 'sol'
          },
          {
            'img': null,
            'id': 'YkhRAayWjqw',
            'title': "SOL - Setting up a Network Connection",
            'index': 3,
            'length': 1,
            'type': 'Operation',
            'tags': [
              'sol', 'operation', 'connection'
            ],
            'date': '2021-09-083T15:50+00Z',
            'section': 'sol'

          }, {
            'img': null,
            'id': 'R2Q6T4RKuW8',
            'title': "SOL - Updating the Firmware",
            'index': 4,
            'length': 1,
            'type': 'Operation',
            'tags': [
              'sol', 'operation', 'firmware'
            ],
            'date': '2021-09-233T15:50+00Z',
            'section': 'sol'
          }, {
            'img': null,
            'id': 'Sfb3NSlPW7g',
            'title': "SOL - Print Process",
            'index': 5,
            'length': 2,
            'type': 'Operation',
            'tags': [
              'sol', 'operation', 'print'
            ],
            'date': '2021-09-233T15:50+00Z',
            'section': 'sol'
          }, {
            'img': null,
            'id': 'gq4sOJdiq30',
            'title': "SOL - Removing Print from Build Platform",
            'index': 6,
            'length': 1,
            'type': 'Operation',
            'tags': [
              'sol', 'operation', 'print removal'
            ],
            'date': '2021-09-133T15:50+00Z',
            'section': 'sol'
          }, {
            'img': null,
            'id': 'Eb8Ksc3cCm0',
            'title': "SOL - Using the Clean Vat Function",
            'index': 7,
            'length': 1,
            'type': 'Operation',
            'tags': [
              'sol', 'operation', 'vat'
            ],
            'date': '2021-09-133T15:50+00Z',
            'section': 'sol'
          }, {
            'img': null,
            'id': 'lmUbxHB7OqU',
            'title': "SOL - Cleaning the Vat",
            'index': 8,
            'length': 2,
            'type': 'Operation',
            'tags': [
              'sol', 'operation', 'vat', 'cleaning'
            ],
            'date': '2021-09-133T15:50+00Z',
            'section': 'sol'
          }, {
            'img': null,
            'id': 'bT3WHMhOm-E',
            'title': "SOL - Restoring Factory Settings",
            'index': 9,
            'length': 1,
            'type': 'Operation',
            'tags': [
              'sol', 'operation', 'settings'
            ],
            'date': '2021-09-133T15:50+00Z',
            'section': 'sol'
          }, {
            'img': null,
            'id': 'U59ErJJGT9k',
            'title': "SOL - Testing the LCD Panel",
            'index': 10,
            'length': 1,
            'type': 'Operation',
            'tags': [
              'sol', 'operation', 'LCD Panel'
            ],
            'date': '2021-10-133T15:50+00Z',
            'section': 'sol'
          }, {
            'img': null,
            'id': 'Z7w158HEzhs',
            'title': "SOL - Replacing the Print Screen",
            'index': 11,
            'length': 3,
            'type': 'Operation',
            'tags': [
              'sol', 'operation', 'screen'
            ],
            'date': '2021-10-133T15:50+00Z',
            'section': 'sol'
          }, {
            'img': null,
            'id': 'LQF3FQoXxKA',
            'title': "SOL - Timelapse: Small vs Large Build Platform",
            'index': 12,
            'length': 1,
            'type': 'Build Platform',
            'tags': [
              'sol', 'build platform', 'comparison'
            ],
            'date': '2022-03-093T15:50+00Z',
            'section': 'sol'
          }, {
            'img': null,
            'id': 'NrqG6AgajIY',
            'title': "SOL - Timelapse: Medium vs Large Build Platform",
            'index': 13,
            'length': 1,
            'type': 'Build Platform',
            'tags': [
              'sol', 'build platform', 'comparison'
            ],
            'date': '2022-03-093T15:50+00Z',
            'section': 'sol'
          }, {
            'img': null,
            'id': 'dj9EyLKUFyc',
            'title': "SOL - Meet the Medium & Small Build Platform",
            'index': 14,
            'length': 1,
            'type': 'Build Platform',
            'tags': [
              'sol', 'build platform', 'medium', 'small'
            ],
            'date': '2022-04-143T15:50+00Z',
            'section': 'sol'
          }, {
            'img': null,
            'id': 'QDyx-y58vqk',
            'title': "SOL - Intro Medium & Small Build Platform",
            'index': 15,
            'length': 4,
            'type': 'Build Platform',
            'tags': [
              'sol', 'build platform', 'medium', 'small'
            ],
            'date': '2022-03-153T15:50+00Z',
            'section': 'sol'
          }, {
            'img': null,
            'id': 'CySSe_LT4jw',
            'title': "SOL - Offline Mode",
            'index': 16,
            'length': 1,
            'type': 'Operation',
            'tags': [
              'sol', 'operation', 'connection'
            ],
            'date': '2022-11-20T15:50+00Z',
            'section': 'sol'
          },
          {
            'img': null,
            'id': 'SRdK7UONX94',
            'title': "Unboxing SOL with Concierge Service",
            'index': 17,
            'length': 4,
            'type': 'Unboxing',
            'tags': [
              'sol', 'operation'
            ],
            'date': '2023-07-11T15:50+00Z',
            'section': 'sol'
          },
// sol plus
          {
            'img': null,
            'id': 'w9govfB3_e0',
            'title': "SOL Plus - Unboxing SOL Plus",
            'index': 0,
            'length': 4,
            'type': 'Unboxing',
            'tags': [
              'sol-plus', 'operation'
            ],
            'date': '2023-07-11T15:50+00Z',
            'section': 'sol-plus'
          },
          {
            'img': null,
            'id': 'tdSGS6y2bpo',
            'title': "SOL Plus - Unboxing SOL Plus with Concierge Service",
            'index': 1,
            'length': 3,
            'type': 'Unboxing',
            'tags': [
              'sol-plus', 'operation'
            ],
            'date': '2023-07-11T15:50+00Z',
            'section': 'sol-plus'
          },
          {
            'img': null,
            'id': 'L-pq4Z9_olc',
            'title': "SOL Plus - Vat Cleaning Function",
            'index': 2,
            'length': 1,
            'type': 'operation',
            'tags': [
              'sol-plus', 'operation'
            ],
            'date': '2023-07-11T15:50+00Z',
            'section': 'sol-plus'
          },
          {
            'img': null,
            'id': 'pLGAyN5S8wM',
            'title': "SOL Plus - Updating the Firmware",
            'index': 3,
            'length': 0,
            'type': 'operation',
            'tags': [
              'sol-plus', 'operation', 'connection'
            ],
            'date': '2023-07-11T15:50+00Z',
            'section': 'sol-plus'
          },
          {
            'img': null,
            'id': 'vcfWKuLmY5E',
            'title': "SOL Plus - Setting up a Network Connection",
            'index': 4,
            'length': 1,
            'type': 'operation',
            'tags': [
              'sol-plus', 'operation', 'connection'
            ],
            'date': '2023-07-11T15:50+00Z',
            'section': 'sol-plus'
          },
          {
            'img': null,
            'id': 'XqyUvPQ7e90',
            'title': "SOL Plus - Set Up",
            'index': 5,
            'length': 0,
            'type': 'operation',
            'tags': [
              'sol-plus', 'operation'
            ],
            'date': '2023-07-11T15:50+00Z',
            'section': 'sol-plus'
          },
          {
            'img': null,
            'id': 'fS23s_BovTo',
            'title': "SOL Plus - Print Process",
            'index': 6,
            'length': 3,
            'type': 'operation',
            'tags': [
              'sol-plus', 'operation', 'print'
            ],
            'date': '2023-07-11T15:50+00Z',
            'section': 'sol-plus'
          },
          {
            'img': null,
            'id': 's3mu8aj0wmA',
            'title': "SOL Plus - Offline Mode",
            'index': 7,
            'length': 3,
            'type': 'operation',
            'tags': [
              'sol-plus', 'operation', 'connection'
            ],
            'date': '2023-07-11T15:50+00Z',
            'section': 'sol-plus'
          },
// CLEANI
          {
            'img': null,
            'id': 'LaQ_ncrinco',
            'title': "Unboxing CLEANI with Dual Tanks",
            'index': 0,
            'length': 1,
            'type': 'Unboxing',
            'tags': [
              'cleani', 'operation'
            ],
            'date': '2023-05-15T15:50+00Z',
            'section': 'cleani'
          },
          {
            'img': null,
            'id': 'R6KDUTq1w5E',
            'title': "Unboxing CLEANI with Tank Plus",
            'index': 1,
            'length': 1,
            'type': 'Unboxing',
            'tags': [
              'cleani', 'operation'
            ],
            'date': '2023-05-15T15:50+00Z',
            'section': 'cleani'
          },
          {
            'img': null,
            'id': 'lhbwDB9m_aQ',
            'title': "CLEANI, dual-tank resin washer",
            'index': 2,
            'length': 1,
            'type': 'Intro',
            'tags': [
              'cleani', 'washer'
            ],
            'date': '2023-05-15T15:50+00Z',
            'section': 'cleani'
          },

// CURIE
          {
            'img': null,
            'id': 'hKkn6tftrWQ',
            'title': "CURIE - Unboxing CURIE",
            'index': 0,
            'length': 1,
            'type': 'Unboxing',
            'tags': [
              'curie', 'operation'
            ],
            'date': '2023-05-15T15:50+00Z',
            'section': 'curie'
          }, {
            'img': null,
            'id': 'rpGaxO90aXU',
            'title': "CURIE – Customizing Curing Parameters",
            'index': 1,
            'length': 1,
            'type': 'Operation',
            'tags': [
              'curie', 'pro-tips'
            ],
            'date': '2023-05-15T15:50+00Z',
            'section': 'curie'
          },

// CURIE Plus
          {
            'img': null,
            'id': 'Idyyhs2i2nw',
            'title': "Meet CURIE Plus",
            'index': 0,
            'length': 1,
            'type': 'Intro',
            'tags': [
              'curie-plus', 'intro'
            ],
            'date': '2023-09-12T15:50+00Z',
            'section': 'curie-plus'
          }, {
            'img': null,
            'id': 'OaZWPfDRTM0',
            'title': "Unboxing CURIE Plus",
            'index': 1,
            'length': 1,
            'type': 'Unboxing',
            'tags': [
              'curie-plus', 'set up'
            ],
            'date': '2023-08-29T15:50+00Z',
            'section': 'curie-plus'
          }, {
            'img': null,
            'id': 'iEIXkm7EMiQ',
            'title': "CURIE Plus - Workflow: Setting The Curing Parameters",
            'index': 2,
            'length': 2,
            'type': 'Operation',
            'tags': [
              'curie-plus', 'operation'
            ],
            'date': '2023-09-12T15:50+00Z',
            'section': 'curie-plus'
          },

          // NFinity
          {
            'img': null,
            'id': 'txWD2sNgCL0',
            'title': "Unboxing NFinity",
            'index': 0,
            'length': 1,
            'type': 'Unboxing',
            'tags': [
              'nfinity', 'set up'
            ],
            'date': '2024-08-14T15:50+00Z',
            'section': 'nfinity'
          },
          {
            'img': null,
            'id': 'QUkVDuk0X8Y',
            'title': "Setting Up CURIE Plus and NFinity",
            'index': 1,
            'length': 1,
            'type': 'Operation',
            'tags': [
              'nfinity', 'set up'
            ],
            'date': '2024-08-14T15:50+00Z',
            'section': 'nfinity'
          },
          {
            'img': null,
            'id': 's586SBgVYcI',
            'title': "Curing Process with CURIE Plus and NFinity",
            'index': 2,
            'length': 1,
            'type': 'Operation',
            'tags': [
              'nfinity', 'operation'
            ],
            'date': '2024-08-14T15:50+00Z',
            'section': 'nfinity'
          },
          {
            'img': null,
            'id': '5xSGp36tr-w',
            'title': "Before Using NFinity",
            'index': 3,
            'length': 0.5,
            'type': 'operation',
            'tags': [
              'nfinity', 'set up'
            ],
            'date': '2024-08-14T15:50+00Z',
            'section': 'nfinity'
          },

// dentiq

          {
            'img': null,
            'id': '1nAwU0ag3cU',
            'title': "DENTIQ – Unboxing Your Printer",
            'index': 0,
            'length': 2,
            'type': 'Operation',
            'tags': [
              'dentiq', 'operation', 'unboxing'
            ],
            'date': '2021-04-143T15:50+00Z',
            'section': 'dentiq'
          }, {
            'img': null,
            'id': '7LOCJIx_lzc',
            'title': "DENTIQ – Setting up Your Printer",
            'index': 1,
            'length': 1,
            'type': 'Operation',
            'tags': ['set up'],
            'date': '2021-04-143T15:50+00Z',
            'section': 'dentiq'
          }, {
            'img': null,
            'id': 'PM2puxwzS0k',
            'title': "DENTIQ – Setting up a Wi Fi Connection",
            'index': 2,
            'length': 1,
            'type': 'Operation',
            'tags': ['set up'],
            'date': '2021-05-213T15:50+00Z',
            'section': 'dentiq'
          }, {
            'img': null,
            'id': 'gP0ETF2-tTc',
            'title': "DENTIQ – Updating the Firmware",
            'index': 3,
            'length': 1,
            'type': 'Operation',
            'tags': [
              'settings', 'firmware'
            ],
            'date': '2021-05-213T15:50+00Z',
            'section': 'dentiq'
          }, {
            'img': null,
            'id': 'pQLi3Fz5MUg',
            'title': "DENTIQ – Printing via a USB Device",
            'index': 4,
            'length': 1,
            'type': 'Operation',
            'tags': [
              'settings', 'USB'
            ],
            'date': '2021-04-143T15:50+00Z',
            'section': 'dentiq'
          }, {
            'img': null,
            'id': 'xSBfPwoeP0A',
            'title': "DENTIQ – Printing via a Computer",
            'index': 5,
            'length': 1,
            'type': 'Operation',
            'tags': [
              'settings', 'computer'
            ],
            'date': '2021-05-073T15:50+00Z',
            'section': 'dentiq'
          }, {
            'img': null,
            'id': '1XKADiecSXg',
            'title': "DENTIQ – Removing the Print from the Build Platform",
            'index': 6,
            'length': 1,
            'type': 'Operation',
            'tags': [
              'post printing', 'build platform'
            ],
            'date': '2021-09-033T15:50+00Z',
            'section': 'dentiq'
          }, {
            'img': null,
            'id': 'ybdFksuZ_-s',
            'title': "DENTIQ – Using the Clean Vat Function",
            'index': 7,
            'length': 1,
            'type': 'Operation',
            'tags': [
              'post printing', 'vat'
            ],
            'date': '2021-09-033T15:50+00Z',
            'section': 'dentiq'
          }, {
            'img': null,
            'id': 'Cobk70A9-qY',
            'title': "DENTIQ – Cleaning the Vat",
            'index': 8,
            'length': 1,
            'type': 'Operation',
            'tags': [
              'post printing', 'vat'
            ],
            'date': '2021-04-123T15:50+00Z',
            'section': 'dentiq'
          }, {
            'img': null,
            'id': 'jwk3OrBdptA',
            'title': "DENTIQ – Workflow Walkthrough",
            'index': 9,
            'length': 2,
            'type': 'Operation',
            'tags': ['workflow'],
            'date': '2021-03-173T15:50+00Z',
            'section': 'dentiq'
          }, {
            'img': null,
            'id': '9le1DbkDFCk',
            'title': "DENTIQ – Replacing the Print Screen",
            'index': 10,
            'length': 1,
            'type': 'Operation',
            'tags': ['maintenance'],
            'date': '2021-06-043T15:50+00Z',
            'section': 'dentiq'
          }, {
            'img': null,
            'id': 'S6Vxs8ucJW0',
            'title': "DENTIQ – Restoring Factory Settings",
            'index': 11,
            'length': 1,
            'type': 'Operation',
            'tags': ['settings'],
            'date': '2021-05-213T15:50+00Z',
            'section': 'dentiq'
          }, {
            'img': null,
            'id': 'dDDMEVY8YpY',
            'title': "DENTIQ – Testing the LCD Panel",
            'index': 12,
            'length': 1,
            'type': 'Operation',
            'tags': ['LCD panel'],
            'date': '2021-07-083T15:50+00Z',
            'section': 'dentiq'
          },

// ALPHA AI
          {
            'img': null,
            'id': 'Yn3kWUOgfzc',
            'title': "Introducing: ALPHA AI - AI-Assisted Dental 3D Printing Slicing Software",
            'index': 0,
            'length': 1,
            'type': 'Intro',
            'tags': ['software'],
            'date': '2023-04-11T15:50+00Z',
            'section': 'alpha-ai',
          },
          {
            'img': null,
            'id': 'VoLbCy4sE-4',
            'title': "How to Download and Upgrade ALPHA AI",
            'index': 1,
            'length': 2,
            'type': 'Intro',
            'tags': ['software'],
            'date': '2023-10-27T15:50+00Z',
            'section': 'alpha-ai'
          },
          {
            'img': null,
            'id': 'wJ6h9FQmSe8',
            'title': "ALPHA AI: View and Movements",
            'index': 2,
            'length': 3,
            'type': 'Intro',
            'tags': ['software'],
            'date': '2023-11-15T15:50+00Z',
            'section': 'alpha-ai'
          },
          {
            'img': null,
            'id': 'tDANHG634XM',
            'title': "ALPHA AI: Supports",
            'index': 3,
            'length': 2,
            'type': 'Intro',
            'tags': ['software'],
            'date': '2023-11-15T15:50+00Z',
            'section': 'alpha-ai'
          },

// Ackuretta Concierge
          {
            'img': null,
            'id': 'zTzIC7-jKG8',
            'title': "Concierge Service Unboxing",
            'index': 0,
            'length': 1,
            'type': 'Operation',
            'tags': [
              'ackuretta concierge', 'unboxing', 'operation'
            ],
            'date': '2023-10-11T15:50+00Z',
            'section': 'ackuretta-concierge'
          },

// User Dashboard
          {
            'img': null,
            'id': 'wxboBaZN0LA',
            'title': "Account Registration",
            'index': 0,
            'length': 1,
            'type': 'intro',
            'tags': [
              'user-dashboard'
            ],
            'date': '2023-10-27T15:50+00Z',
            'section': 'user-dashboard'
          },

// alpha3D

/*
          {
            'img': null,
            'id': 'fFfyMWWmjSc',
            'title': "Alpha 3D – Getting Started",
            'index': 0,
            'length': 2,
            'type': 'Tutorial',
            'tags': ['training'],
            'date': '2021-09-033T15:50+00Z',
            'section': 'alpha3d'
          }, {
            'img': null,
            'id': 'dum58Yh3xk4',
            'title': "Alpha 3D – Workflow",
            'index': 1,
            'length': 2,
            'type': 'Tutorial',
            'tags': ['training'],
            'date': '2021-09-033T15:50+00Z',
            'section': 'alpha3d'
          }, {
            'img': null,
            'id': '5QWA-f6S8EM',
            'title': "Alpha 3D – View & Movement",
            'index': 2,
            'length': 3,
            'type': 'Tutorial',
            'tags': [
              'training', 'view'
            ],
            'date': '2021-09-033T15:50+00Z',
            'section': 'alpha3d'
          }, {
            'img': null,
            'id': 'sd6XU90iZVM',
            'title': "Alpha 3D – Supports",
            'index': 3,
            'length': 2,
            'type': 'Tutorial',
            'tags': ['training'],
            'date': '2021-09-033T15:50+00Z',
            'section': 'alpha3d'
          }, {
            'img': null,
            'id': 'fqIKbZMmPfM',
            'title': "Alpha 3D – Special Features",
            'index': 4,
            'length': 2,
            'type': 'Tutorial',
            'tags': ['features'],
            'date': '2021-09-033T15:50+00Z',
            'section': 'alpha3d'
          }, {
            'img': null,
            'id': '_FQq_cyOeDs',
            'title': "Alpha 3D – Configuration",
            'index': 5,
            'length': 2,
            'type': 'Tutorial',
            'tags': ['settings'],
            'date': '2021-09-033T15:50+00Z',
            'section': 'alpha3d'
          }, {
            'img': null,
            'id': '5XBUawpHEPc',
            'title': "Alpha 3D – How to print with the small & medium build platform with SOL",
            'index': 6,
            'length': 1,
            'type': 'Tutorial',
            'tags': ['platform'],
            'date': '2022-02-253T15:50+00Z',
            'section': 'alpha3d'
          }, {
            'img': null,
            'id': 'SM-I5K7QfTM',
            'title': "Alpha 3D – Adding text to model",
            'index': 7,
            'length': 1,
            'type': 'Tutorial',
            'tags': ['text'],
            'date': '2022-03-033T15:50+00Z',
            'section': 'alpha3d'
          },
*/
// pro tips

          {
            'img': null,
            'id': 'ezt2eaezV0k',
            'title': "How to Successfully Print Hollow Models?",
            'index': 0,
            'length': 2,
            'type': 'PRO TIPS',
            'tags': ['hollow models'],
            'date': '2020-12-213T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': 'G024cFLSfZY',
            'title': "Cleaning a Dirty Vat",
            'index': 1,
            'length': 1,
            'type': 'PRO TIPS',
            'tags': [
              'post printing', 'vat'
            ],
            'date': '2020-12-243T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': 'WSMZDfdOjYk',
            'title': "How to Stir Resin Properly?",
            'index': 2,
            'length': 1,
            'type': 'PRO TIPS',
            'tags': ['resin'],
            'date': '2020-12-303T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': '7K9MeQr3rTE',
            'title': "Preventing the Z-axis Issue",
            'index': 3,
            'length': 1,
            'type': 'PRO TIPS',
            'tags': ['Z-axis'],
            'date': '2021-01-073T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': 'bPq9gT4Cnms',
            'title': "Support Settings for Crowns",
            'index': 4,
            'length': 2,
            'type': 'PRO TIPS',
            'tags': [
              'support', 'crowns', 'software'
            ],
            'date': '2021-01-083T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': 'ORPZBPRG9gQ',
            'title': "Manual Supports in Alpha 3D",
            'index': 5,
            'length': 2,
            'type': 'PRO TIPS',
            'tags': [
              'support', 'software'
            ],
            'date': '2021-01-123T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': 'nEVRM2O7ruI',
            'title': "Cleaning The Vat",
            'index': 6,
            'length': 1,
            'type': 'PRO TIPS',
            'tags': [
              'post printing', 'vat'
            ],
            'date': '2021-01-203T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': '393Goo6Qfqo',
            'title': "Removing Surgical Guides from the Build Platform",
            'index': 7,
            'length': 1,
            'type': 'PRO TIPS',
            'tags': [
              'post printing', 'build platform'
            ],
            'date': '2021-01-253T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': 'McuDgzGIaew',
            'title': "5 Basic Safety Rules",
            'index': 8,
            'length': 1,
            'type': 'PRO TIPS',
            'tags': ['safety'],
            'date': '2021-01-293T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': 'baIB-cFHpo0',
            'title': "Shaking the Resin",
            'index': 9,
            'length': 1,
            'type': 'PRO TIPS',
            'tags': ['resin'],
            'date': '2021-08-133T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': 'PImBGkDLSSM',
            'title': "Finding Your Printer's IP Address",
            'index': 10,
            'length': 1,
            'type': 'PRO TIPS',
            'tags': ['settings'],
            'date': '2021-09-103T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': 'NNoSsWL-bLQ',
            'title': "Flawless Post-Processing",
            'index': 11,
            'length': 3,
            'type': 'PRO TIPS',
            'tags': ['post printing'],
            'date': '2021-08-263T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': 'vsFYWP7kuoo',
            'title': "Washing Small Prints with CLEANI",
            'index': 12,
            'length': 1,
            'type': 'PRO TIPS',
            'tags': ['post printing'],
            'date': '2021-09-303T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': 'Xsn3QEhYlLE',
            'title': "Proper Placement of the Build Platform",
            'index': 13,
            'length': 1,
            'type': 'PRO TIPS',
            'tags': ['build platform'],
            'date': '2021-10-183T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': 'nMX6gr-7VLs',
            'title': "Vat Management",
            'index': 14,
            'length': 2,
            'type': 'PRO TIPS',
            'tags': ['vat'],
            'date': '2021-10-283T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': 's8gPMLky4wk',
            'title': "Cleaning your Equipment",
            'index': 15,
            'length': 7,
            'type': 'PRO TIPS',
            'tags': ['post printing'],
            'date': '2021-10-293T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': 'rpGaxO90aXU',
            'title': "Custom curing settings to Curie",
            'index': 16,
            'length': 1,
            'type': 'PRO TIPS',
            'tags': [
              'post printing', 'curie', 'settings'
            ],
            'date': '2021-12-013T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': '0meJ52VrYNE',
            'title': "Efficiently Orientating Models in Alpha 3D",
            'index': 17,
            'length': 4,
            'type': 'PRO TIPS',
            'tags': ['software'],
            'date': '2021-12-013T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': '4ioXlyaP4_k',
            'title': "Managing Your Resins",
            'index': 18,
            'length': 1,
            'type': 'PRO TIPS',
            'tags': ['resin'],
            'date': '2021-12-133T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': 'd4-B75k-7Hg',
            'title': "Preparing Splints in Alpha 3D",
            'index': 19,
            'length': 2,
            'type': 'PRO TIPS',
            'tags': [
              'software', 'splint'
            ],
            'date': '2021-12-173T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': '-48wuUE5uJI',
            'title': "ProTip #20 - Medit Link Splint Design & Integration with Ackuretta Alpha 3D - By Dr. Tom Shao",
            'index': 20,
            'length': 6,
            'type': 'PRO TIPS',
            'tags': [
              'resin', 'software', 'medit', 'splints'
            ],
            'date': '2021-11-073T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': 'm3JA0BSmtx0',
            'title': "Ackuretta & Medit - Workflow - Design & 3D Printing Crowns",
            'index': 21,
            'length': 1,
            'type': 'PRO TIPS',
            'tags': [
              'resin',
              'software',
              'medit',
              'dental crowns',
              '3d printed crowns'
            ],
            'date': '2022-11-16T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': 'G9J5E1Lw3TY',
            'title': "Ackuretta & Medit - Workflow - Design & 3D Printing Models",
            'index': 22,
            'length': 1,
            'type': 'PRO TIPS',
            'tags': [
              'resin',
              'software',
              'medit',
              'dental models',
              '3d printed models'
            ],
            'date': '2022-11-16T15:50+00Z',
            'section': 'protips'
          }, {
            'img': null,
            'id': 'g0u90f97aas',
            'title': "Ackuretta & Medit - Workflow - Design & 3D Printing Splints",
            'index': 23,
            'length': 1,
            'type': 'PRO TIPS',
            'tags': [
              'resin',
              'software',
              'medit',
              'splints',
              '3d printed splints'
            ],
            'date': '2022-11-16T15:50+00Z',
            'section': 'protips'
          },

// testimonials

          {
            'img': null,
            'id': 'BTuACH7_mdg',
            'title': "Dr. Fermin Ocañas gets his SOL 3D Printer",
            'index': 0,
            'length': 8,
            'type': 'TESTIMONIALS',
            'tags': ['sol'],
            'date': '2021-09-303T15:50+00Z',
            'section': 'testimonials'
          }, {
            'img': null,
            'id': 'IMP_SY_k5yY',
            'title': "Miguel Perez - Colloquium Dental 2019",
            'index': 1,
            'length': 1,
            'type': 'TESTIMONIALS',
            'tags': ['colloquium dental'],
            'date': '2021-01-173T15:50+00Z',
            'section': 'testimonials'
          }, {
            'img': null,
            'id': '1OwrDNYHuEk',
            'title': "Matteo Bonacina - Colloquium Dental 2019",
            'index': 2,
            'length': 2,
            'type': 'TESTIMONIALS',
            'tags': ['colloquium dental'],
            'date': '2019-12-233T15:50+00Z',
            'section': 'testimonials'
          },

//webinars
          {
            'img': null,
            'id': 'hpEKMVa7flA',
            'title': "Ackuretta Webinar: SOL Plus + 3D Printing Solution Plus - Live Launch Event",
            'index': 0,
            'length': 52,
            'type': 'WEBINARS',
            'tags': ['webinars'],
            'date': '2023-12-26T15:50+00Z',
            'section': 'webinars'
          },
          {
            'img': null,
            'id': '1BptD95BOhU',
            'title': "Ackuretta Webinar: Scan to Delivery - 3D Printed Splints ft Dr. Tom Shao",
            'index': 1,
            'length': 56,
            'type': 'WEBINARS',
            'tags': ['webinars'],
            'date': '2023-12-26T15:50+00Z',
            'section': 'webinars'
          },
          {
            'img': null,
            'id': '2EMXFmgo9oA',
            'title': "Ackuretta Webinar: 3D Printing Made Easy ft. Dr. Russell Schafer",
            'index': 2,
            'length': 54,
            'type': 'WEBINARS',
            'tags': ['webinars'],
            'date': '2023-12-26T15:50+00Z',
            'section': 'webinars'
          },
          {
            'img': null,
            'id': 'DdAtAeuu4GQ',
            'title': "Ackuretta Webinars: The 1 Hour Crown Workflow by Prof. Adam Nulty ft. BEGO & Evident",
            'index': 3,
            'length': 103,
            'type': 'WEBINARS',
            'tags': ['webinars'],
            'date': '2023-12-26T15:50+00Z',
            'section': 'webinars'
          },
          {
            'img': null,
            'id': 'Klg_RlXXZyk',
            'title': "Webinar ft Dr. Rick Ferguson: Solutions to the 5 Most Common Problems in Dental 3D Printing",
            'index': 4,
            'length': 60,
            'type': 'WEBINARS',
            'tags': ['webinars'],
            'date': '2023-12-26T15:50+00Z',
            'section': 'webinars'
          }, {
            'img': null,
            'id': 'EJEBMtjLoEo',
            'title': "Ackuretta's Webinar - Introduction to Model Printing with Jed Archibald and Jessica Knott",
            'index': 5,
            'length': 80,
            'type': 'WEBINARS',
            'tags': ['webinars'],
            'date': '2023-12-26T15:50+00Z',
            'section': 'webinars'
          }, {
            'img': null,
            'id': 'a-dwRiamBkM',
            'title': "Ackuretta & BEGO Webinar - 3D Printing in Restorative Dentistry",
            'index': 6,
            'length': 84,
            'type': 'WEBINARS',
            'tags': ['webinars'],
            'date': '2023-12-26T15:50+00Z',
            'section': 'webinars'
          }, {
            'img': null,
            'id': 'PqaBfnp5VuY',
            'title': "Intro to Dental 3D Printing with Dr. Nitish Surathu",
            'index': 7,
            'length': 72,
            'type': 'WEBINARS',
            'tags': ['webinars'],
            'date': '2023-12-26T15:50+00Z',
            'section': 'webinars'
          },

          {
            'img': null,
            'id': 'GXeJv0Cw0-g',
            'title': "Intro to 3D Printing ft. Eugene Royzengurt",
            'index': 8,
            'length': 95,
            'type': 'WEBINARS',
            'tags': ['webinars'],
            'date': '2023-12-26T15:50+00Z',
            'section': 'webinars'
          },


          {
          'img': null,
          'id': 'TEBMGTDu8fo',
          'title': "Is milling obsolete endless possibilities with 3D printing ft. Lee Culp",
          'index': 9,
          'length': 75,
          'type': 'WEBINARS',
          'tags': ['webinars'],
          'date': '2023-12-26T15:50+00Z',
          'section': 'webinars'
          },
          {
          'img': null,
          'id': 'AM50emyam_8',
          'title': "What's new? An intro to ALPHA AI & User Dashboard - 1",
          'index': 10,
          'length': 41,
          'type': 'WEBINARS',
          'tags': ['webinars'],
          'date': '2023-12-26T15:50+00Z',
          'section': 'webinars'
          },
          {
          'img': null,
          'id': 'ReMhZWdSmDQ',
          'title': "Intro to Dental 3D Printing with Dr. Chonway Tram",
          'index': 11,
          'length': 57,
          'type': 'WEBINARS',
          'tags': ['webinars'],
          'date': '2023-12-26T15:50+00Z',
          'section': 'webinars'
          },
          {
          'img': null,
          'id': 'AtU0gmDhFRE',
          'title': "What's new? An intro to ALPHA AI & User Dashboard - 2",
          'index': 12,
          'length': 41,
          'type': 'WEBINARS',
          'tags': ['webinars'],
          'date': '2023-12-26T15:50+00Z',
          'section': 'webinars'
          },
          {
          'img': null,
          'id': 'AnlLjEWokWk',
          'title': "Digital Implant Planning For Guided Surgery ft. Dr. Arunachalam Dhandapani",
          'index': 13,
          'length': 67,
          'type': 'WEBINARS',
          'tags': ['webinars'],
          'date': '2023-12-26T15:50+00Z',
          'section': 'webinars'
          },
          {
          'img': null,
          'id': 'NfwmMWJXI4E',
          'title': "Say Goodbye to User Error ft. Dr. Nitish Surathu - APAC",
          'index': 14,
          'length': 83,
          'type': 'WEBINARS',
          'tags': ['webinars'],
          'date': '2023-12-26T15:50+00Z',
          'section': 'webinars'
          },
          {
          'img': null,
          'id': 'dTRwSvsh1xY',
          'title': "Say Goodbye to User Error ft. Dr. Nitish Surathu - US",
          'index': 15,
          'length': 68,
          'type': 'WEBINARS',
          'tags': ['webinars'],
          'date': '2023-12-26T15:50+00Z',
          'section': 'webinars'
          },
          {
          'img': null,
          'id': '7q5kSidAwNE',
          'title': "From Scan to 3D Print: Dental Model Printing",
          'index': 16,
          'length': 53,
          'type': 'WEBINARS',
          'tags': ['webinars'],
          'date': '2023-12-26T15:50+00Z',
          'section': 'webinars'
          }
        ]
      }
    },
    methods: {
      ...Vuex.mapActions(['setPageIsLoading']),
      //...Vuex.mapActions('sliders', ['getSlideList'])
      scrollToTop() {
        window.scrollTo({top: 115, left: 100, behavior: 'smooth'})
      },

      selectVideo(video) {
        this.currentVideo = video
        document.title = 'Ackuretta | Video Gallery' + ` | ${
          this.currentVideoTitle
        }`
        this.openVideo()

        let url = new URL(window.location.href);
        url.searchParams.set('videoId', video.id);
        window.history.pushState({}, '', url);
      },

      openVideo() {
        this.displayingVideo = true
        this.scrollToTop()
      },

      closeVideo() {
        this.displayingVideo = false

        this.currentVideo = null

        document.title = 'Ackuretta | Video Gallery'

        if (history.pushState) {
          let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
          window.history.pushState({path:newUrl},'',newUrl);
        }
      },

      getSectionVideos(sectionName) {
        let arr = []

        for (let index = 0; index < this.videos.length; index++) {
          const element = this.videos[index];

          if (element.section === sectionName) {
            arr.push(element)
          }

        }

        return arr
      },

      openSearchResults() {
        this.displayingSearchResults = true
        gsap.fromTo('#search-results .video-item', {
          opacity: 0,
          scale: 0.5
        }, {
          duration: 1,
          opacity: 1,
          scale: 1,
          stagger: 0.2
        });
        this.scrollToTop()
      },

      closeSearchResults() {
        this.displayingSearchResults = false
      },

      search() {
        let videoResults = []
        let termsArr = []
        termsArr = this
          .searchTerms
          .split(' ')

          for (let index = 0; index < termsArr.length; index++) {
            const term = termsArr[index].toLowerCase()

            for (let index = 0; index < this.videos.length; index++) {
              const element = this.videos[index];
              if (videoResults.includes(element)) {
                continue
              }

              if (element.title.toLowerCase().includes(term)) {
                videoResults.push(element)
              } else {
                if (element.tags.includes(term)) {
                  videoResults.push(element)
                } else {
                  if (element.type.includes(term)) {
                    videoResults.push(element)
                  }
                }
              }

              if (videoResults.includes(element)) {
                continue
              } else {
                if (element.title.toLowerCase().indexOf(term) !== -1) {
                  videoResults.push(element)
                } else {
                  if (JSON.stringify(element.tags).indexOf(term) !== -1) {
                    videoResults.push(element)
                  } else {
                    if (element.type.indexOf(term) !== -1) {
                      videoResults.push(element)
                    }
                  }
                }
              }

            }
          }

          console
          .log(videoResults)
          this
          .searchResults = videoResults

        this.openSearchResults()
      },

      searchByTag(tag) {
        let videoResults = []

        for (let index = 0; index < this.videos.length; index++) {
          const element = this.videos[index];
          if (videoResults.includes(element)) {
            continue
          }

          if (element.tags.includes(tag)) {
            videoResults.push(element)
          }

        }

        this.searchResults = videoResults

        this.openSearchResults()
      },

      searchByType(type) {
        let videoResults = []

        for (let index = 0; index < this.videos.length; index++) {
          const element = this.videos[index];
          if (videoResults.includes(element)) {
            continue
          }

          if (element.type === type) {
            videoResults.push(element)
          }

        }

        this.searchResults = videoResults

        this.openSearchResults()
      }
    },
    beforeDestroy() {

    },
    watch: {

      data1: {
        handler() {



        },
        deep: false
      }
    }
  })